import { Crown } from "lucide-react";

/** Small "Points leader" style chips for team stat leaders. */
export const LeaderBadges = ({ badges, testid }) => (Array.isArray(badges) && badges.length ? (
  <div data-testid={testid} className="flex flex-wrap gap-1.5">
    {badges.map((b) => (
      <span key={b.key} data-testid={`${testid}-${b.key}`} title={`Team leader: ${b.value} per game`}
        className="inline-flex items-center gap-1 rounded-full border border-[#F5C542]/50 bg-[#F5C542]/10 px-2 py-0.5 font-mono-gd text-[11px] font-bold uppercase tracking-wider text-[#F5C542]">
        <Crown className="h-3 w-3" />{b.label} leader
      </span>
    ))}
  </div>
) : null);
